<template>
  <div class="concat-us">
    <div class="concat-us-hd">联系我们</div>
    <div
      class="concat-us-item"
      v-for="(item, index) in list"
      v-bind:style="{ height: item.height + 'px' }"
      :key="index"
    >
      <div style="font-size: 20px">{{ item.name }}</div>
      <div style="font-size: 12px; height: 40px; color: #999">
        {{ item.sub }}
      </div>
      <div class="blue mobile-people">{{ item.people }}</div>
      <div>
        Tel：<span class="blue">{{ item.phone }}</span>
      </div>
      <div>Email：{{ item.email }}</div>
      <div>QQ：{{ item.qq }}</div>
    </div>
    <div class="concat-us-position">
      <img src="@/static/images/zzgy.jpg" class="map" />
      <div class="content">
        <div>公司地址<span v-if="!isMobile"> ：</span></div>
        <div class="addr">
          {{config.concat.guiyang_dizhi}}
          <br />总机：{{config.concat.zongji}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { LOGIN_API } from "@/api.js";
import { list } from './config'
export default {
  name: 'concat-us',
  data() {
    return {
      list: [],
      isMobile: false,
    }
  },

  mounted() {
    this.isMobile = this.$store.state.app.device
    this.getAbout()
  },
  computed: {
    config() {
      return this.$store.state.app.config
    },
  },
  methods: {
    getAbout() {
      let post = {
        category: 35,
      }
      this.$axios
        .post(`${LOGIN_API}/customer/api/config`, post)
        .then((res) => {
          if (res.data.errno == 0) {
            if (res.data.result && res.data.result.length > 0) {
              this.list = res.data.result[0].data
            }
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.concat-us {
  width: 1200px;
  margin: auto;
  line-height: 24px;
  font-weight: 300;
  position: relative;
  padding-bottom: 20px;
  min-height: 620px;
  .blue {
    color: #29bdb9;
  }
  .concat-us-hd {
    font-size: 24px;
    text-align: center;
    padding: 35px;
  }
  .concat-us-item {
    background-color: #fff;
    border: 1px solid #ededed;
    padding: 20px;
    display: inline-block;
    width: 580px;
    height: 220px !important;
    margin: 10px;
    font-size: 14px;

    div {
      padding: 2px 0;
    }
  }
  .concat-us-position {
    background-color: #fff;
    position: absolute;
    border: 1px solid #ededed;
    padding: 7px 20px 5px 5px;
    width: 580px;
    height: 220px;
    margin: 10px;
    top: 334px;
    right: 0px;
    display: flex;
    .content {
      font-size: 24px;
      padding: 40px 20px;
      .addr {
        font-size: 14px;
        line-height: 24px;
        padding-top: 40px;
      }
    }
    .map {
      max-height: 200px;
    }
  }
}
@media screen and (max-width: 600px) {
  .concat-us {
    width: initial;
    .concat-us-item {
      width: initial;

      .mobile-people {
        padding-top: 10px;
      }
    }
    .concat-us-position {
      position: initial;
      display: block;
      width: initial;
      height: inherit;
      padding: 10px;
      .map {
        width: 100%;
        max-height: inherit;
      }
      .content {
        padding: 30px 0px;
        width: 180px;
        margin: 0px auto;
        text-align: center;
        letter-spacing: 2px;
        .addr {
          padding-top: 20px;
        }
      }
    }
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .concat-us {
    width: 80%;
    .concat-us-item {
      width: 100%;

      .mobile-people {
        padding-top: 10px;
      }
    }
    .concat-us-position {
      position: initial;
      display: block;
      width: 100%;
      height: inherit;
      padding: 10px;
      .map {
        width: 100%;
        max-height: inherit;
      }
      .content {
        padding: 30px 0px;
        width: 180px;
        margin: 0px auto;
        text-align: center;
        letter-spacing: 2px;
        .addr {
          padding-top: 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/concat-us/index.vue